import React from 'react'

import { FlexCol } from '../../../../components/structure/FlexGrid'
import Separator from '../../../../components/helpers/Separator'
import LabelValue from '../../../../components/pdf/LabelValue'
import Gallery from '../../../../components/pdf/Gallery'

const Documents = ({ serviceOrder }) => {
  const { documents = [] } = serviceOrder || {}

  if (!documents || !documents?.length) return false

  return (
    <FlexCol width="100%">
      <LabelValue label="Documentos">
        <Separator weight={1} />
        <Gallery items={documents} thumbHeight="7rem" />
      </LabelValue>
    </FlexCol>
  )
}

export default Documents
